import { Tooltip } from '@mui/material'
import { C1IconButton } from 'c1ui'
import { C1Icon } from 'components/core/icons/C1Icon'
import { useHasAnyBuiltinRole } from 'components/no-ui/capability'
import { transparentStyling } from 'components/pages/app-bar/C1AppBar'
import { C1AppBarStyles } from 'components/pages/app-bar/styles'
import { RoleID } from 'lib/constants/system'
import { Search } from 'lucide-react'
import { FC, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { Spotlight } from './Spotlight'

export const SpotlightContainer: FC = () => {
    const intl = useIntl()
    const [searchOpen, setSearchOpen] = useState(false)
    const hasRoleGreaterThanBasicUser = useHasAnyBuiltinRole(Object.values(RoleID).filter((role) => role !== RoleID.BasicUser))
    const isMac = /Mac|iPod|iPhone|iPad/.test(navigator.userAgent)

    useEffect(() => {
        const handleKeyPress = (event): void => {
            if ((event.ctrlKey || event.metaKey) && event.key === 'k') {
                event.preventDefault()
                event.stopPropagation()
                setSearchOpen(true)
            }
        }

        window.addEventListener('keydown', handleKeyPress)

        return () => {
            window.removeEventListener('keydown', handleKeyPress)
        }
    }, [])

    const handleCloseSearch = (): void => {
        setSearchOpen(false)
    }
    return <>
        {hasRoleGreaterThanBasicUser && <Tooltip
            PopperProps={{ sx: C1AppBarStyles.tooltipPopper }}
            title={`${intl.formatMessage({ id: 'spotlight_search_shortcut', defaultMessage: 'Search' })} ( ${isMac ? '⌘' : 'Ctrl'} + k )`}
        >
            <span>
                <C1IconButton
                    color="inherit"
                    sx={transparentStyling}
                    size="small"
                    onClick={(): void => { setSearchOpen(true) }}
                    aria-label={intl.formatMessage({ id: 'spotlight_search_shortcut', defaultMessage: 'Search' })}
                >
                    <C1Icon icon={Search} />
                </C1IconButton>
            </span>
        </Tooltip>}
        <Spotlight open={searchOpen} onClose={handleCloseSearch} />
    </>
}
